// extracted by mini-css-extract-plugin
export default {"draggable":"SortableContainer_draggable__X7fKQ","draggableItem":"SortableContainer_draggableItem__JR9LP","drag":"SortableContainer_drag__HMdV6"};